import { PartnerDashboardData } from 'src/modules/partner-dashboard/types/PartnerDashboardData';
import { createTrigger } from 'src/utils/createTrigger';

export const PARTNER_DASHBOARD_CHECK =
  createTrigger<boolean>('PARTNER_DASHBOARD_CHECK');

export const PARTNER_DASHBOARD_FETCH =
  createTrigger<PartnerDashboardData>('PARTNER_DASHBOARD_FETCH');

export const PARTNER_DASHBOARD_RESET =
  createTrigger<void>('PARTNER_DASHBOARD_RESET');
